module.exports = __webpack_public_path__ + "@/assets/img/05.3f1c3795.svg";